import { render, staticRenderFns } from "./exchangeCalculator.vue?vue&type=template&id=6be9e5dc&"
import script from "./exchangeCalculator.vue?vue&type=script&lang=js&"
export * from "./exchangeCalculator.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports